export const ElectronicFormDataGridStringValidator = (
  datalistvalue,
  datalist
) => {
  for (let i = 0; i < datalistvalue.length; i++) {
    for (let j = 0; j < datalistvalue[i].length; j++) {
      if (datalistvalue[i][j].value === undefined) {
        datalistvalue[i].splice(j, 1);
        j--;
      }
    }
  }

  return datalistvalue
    .map((innerArray) => {
      return innerArray
        .map((content) => {
          if (content.value instanceof Array) {
            return {
              idcommand: `${content.element.NameColumn}=${content.value
                .map(
                  (contentvalue) =>
                    contentvalue.ItemContent ?? contentvalue.label
                )
                .join(",")}#${content.element.IdColumn}=${content.value
                .map(
                  (contentvalue) => contentvalue.id ?? contentvalue.ItemValue
                )
                .join(",")}`,
              value: `${content.element.HeaderColumn}=${content.value
                .map(
                  (contentvalue) =>
                    contentvalue.ItemContent ?? contentvalue.label
                )
                .join(",")}`,
              isArray: true,
            };
          } else {
            return {
              idcommand: `${content.element.NameColumn}=${content.value}`,
              value: content.value,
              isArray: false,
              isRadio: content.element.ElsRecord.Type === "RadioButton",
              isCheckBox: content.element.ElsRecord.Type === "CheckBox",
              HeaderColumn: content.element.HeaderColumn,
            };
          }
        })
        .map((stringArray) => {
          return {
            idcommand: stringArray.isArray
              ? `${stringArray.idcommand}`
              : stringArray.isRadio && stringArray.value === 1
              ? `${stringArray.idcommand}`
              : !stringArray.isRadio
              ? stringArray.isCheckBox
                ? `${stringArray.idcommand}`
                : `${stringArray.idcommand}#${stringArray.value}`
              : undefined,
            value: stringArray.isArray
              ? `${stringArray.value}`
              : `${stringArray.HeaderColumn}=${stringArray.value}`,
          };
        })
        .filter((fl) => fl.idcommand)
        .reduce(
          (accumlator, previous) => ({
            idcommand: `${accumlator.idcommand}#${previous.idcommand}`
              .replace(/^undefined#/, "")
              .replace(/^undefined!/, "")
              .replace(/##/g, "#")
              .replace(/(\w+#)\1+/g, "$1")
              .replace(/(^#|#$)/g, "")
              .replace(/(\b[^#]+#\b)\1+/g, "$1")
              .replace(/(\d{2}:\d{2}#)\d{2}:\d{2}/g, "$1"),
            value: `${accumlator.value}#${previous.value}`
              .replace(/^undefined#/, "")
              .replace(/^undefined\r\n/, "")
              .replace(/##/g, "#")
              .replace(/(\w+#)\1+/g, "$1")
              .replace(/(^#|#$)/g, "")
              .replace(/(\b[^#]+#\b)\1+/g, "$1")
              .replace(/(\d{2}:\d{2}#)\d{2}:\d{2}/g, "$1"),
          }),
          {}
        );
    })
    .reduce((acc, prev) => {
      return {
        idcommand: `${acc.idcommand}!${prev.idcommand}`
          .replace(/^undefined#/, "")
          .replace(/^undefined(!|\r\n)/g, "")
          .replace(/##/g, "#")
          .replace(/(\w+#)\1+/g, "$1")
          .replace(/(^#|#$)/g, "")
          .replace(/(\b[^#]+#\b)\1+/g, "$1")
          .replace(/(\d{2}:\d{2}#)\d{2}:\d{2}/g, "$1"),
        value: `${acc.value}\r\n${prev.value}`
          .replace(/^undefined#/, "")
          .replace(/^undefined(!|\r\n)/g, "")
          .replace(/##/g, "#")
          .replace(/(\w+#)\1+/g, "$1")
          .replace(/(^#|#$)/g, "")
          .replace(/(\b[^#]+#\b)\1+/g, "$1")
          .replace(/(\d{2}:\d{2}#)\d{2}:\d{2}/g, "$1"),
        iddetail: datalist.iddetail,
      };
    }, {});
};
